import { getMemberId } from '@trello/authentication';

export const getAvailableSitesStorageKey = () =>
  `${getMemberId()}-availableSites`;
